<div *ngIf="isVisible" class="fade-out-block" [ngStyle]="errorStyle" [@fadeAnimation]>There was an error completing your reservation. Please enter all fields, select your seats and try again!</div>>
